import { render, staticRenderFns } from "./Lobby5.vue?vue&type=template&id=4ea00a1b"
import script from "./Lobby5.vue?vue&type=script&lang=js"
export * from "./Lobby5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports